import { FC, useState, useEffect } from 'react';
import type { InstructionsInner } from '@commerce-product-webcomponents/sdk';
import { useTranslation } from '@nextgen-web-framework/all';
import type { UsageComponentPropsTypes } from './types/propsTypes';
import styles from './UsageComponent.module.scss';

const UsageComponent: FC<UsageComponentPropsTypes> = ({ usageDetails }: UsageComponentPropsTypes): JSX.Element => {
  const [showUsageReadSection, setShowUsageReadSection] = useState<boolean>(false);
  const [showUsageReadMore, setShowUsageReadMore] = useState<boolean>(true);
  const toggleShowContent = () => {
    setShowUsageReadMore(!showUsageReadMore);
  };
  const minInstructionStep = 5;
  const t = useTranslation();
  const viewMoreLabel = `${t('product.productDetails.read')} ${t('product.productIngredient.viewMore')}`;
  const viewLessLabel = `${t('product.productDetails.read')} ${t('product.productIngredient.viewLess')}`;
  useEffect(() => {
    if ((usageDetails?.length as number) > minInstructionStep) {
      setShowUsageReadSection(true);
    }
  }, [usageDetails?.length]);
  return (
    <>
      {usageDetails?.length > 0 && (
        <div className={`${styles['cpw-usage-container']}`} data-testid={'cpw-usage-container-testid'}>
          <div className={`${styles['how-to-use-title-container']}`}>
            <h4 className={`${styles['how-to-use-title']}`} data-testid={'how-to-use-title-testid'}>
              {t('product.usageComponent.header')}
            </h4>
          </div>
          <div className={`${styles['how-to-use-steps']}`} data-testid={'how-to-use-steps-testid'}>
            {usageDetails?.length > 0 &&
              usageDetails?.map((usageDetail: InstructionsInner, index: number) => {
                if (index >= minInstructionStep && showUsageReadMore) {
                  return null;
                }
                return (
                  <div
                    className={`${styles['usage-container']}`}
                    key={`instruction${index + 1}`}
                    data-testid={`usage-container-testid${index + 1}`}
                  >
                    <div
                      className={`${styles['usage-number-container']}`}
                      data-testid={`usage-number-container-testid${index + 1}`}
                    >
                      <div className={`${styles['usage-number']}`}>{usageDetail.step}</div>
                    </div>
                    <div className={`${styles['usage-details-container']}`}>
                      <div className={`${styles['usage-title']}`} data-testid={`usage-title-testid${index + 1}`}>
                        {usageDetail.stepTitle}
                      </div>
                      <div className={`${styles['usage-content']}`} data-testid={`usage-content-testid${index + 1}`}>
                        {usageDetail.instruction}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          {showUsageReadSection && (
            <div className={`${styles['show-content']} ${showUsageReadMore && styles['margin-top']}`}>
              {showUsageReadMore ? (
                <span
                  data-testid="details-more-id"
                  role="button"
                  onClick={toggleShowContent}
                  tabIndex={0}
                  onKeyDown={toggleShowContent}
                  aria-label={viewMoreLabel}
                >
                  {viewMoreLabel}
                </span>
              ) : (
                <span
                  data-testid="details-less-id"
                  role="button"
                  onClick={toggleShowContent}
                  tabIndex={0}
                  aria-label={viewLessLabel}
                  onKeyDown={toggleShowContent}
                >
                  {viewLessLabel}
                </span>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default UsageComponent;
export type { UsageComponentPropsTypes };
